import { generateId } from '@freelancer/datastore/testing/helpers';
import type { FlareAdminLog } from './flare-admin-logs.model';

export interface GenerateFlareAdminLog {
  readonly id?: number;
  readonly flareCheckpointId: number;
  readonly flareRulesetId: number;
  readonly reason: string;
  readonly dateCreated: number;
  readonly adminName: string;
}

/**
 * Create a Freelancer Automation Rule Engine (FLARE) admin log object
 */
export function generateFlareAdminLogObject({
  id = generateId(),
  flareCheckpointId,
  flareRulesetId,
  reason,
  dateCreated,
  adminName,
}: GenerateFlareAdminLog): FlareAdminLog {
  return {
    id,
    flareCheckpointId,
    flareRulesetId,
    reason,
    dateCreated,
    adminName,
  };
}
